import { computed, useContext, useRoute } from '@nuxtjs/composition-api';
import { castArray } from 'lodash-es';
import { COOKIE_KEY } from '~/constants';
import { url } from '~/utils';
import { DECConnectId } from '~/enums';

export type SocialLoginParams = {
  code: string | null;
  identifier: string | null;
  state: string | null;
};

export const useDECConnect = () => {
  const { $cookies, redirect } = useContext();
  const route = useRoute();

  const dconId = computed(() => {
    const dconId = $cookies.get(COOKIE_KEY.DCON_ID, { parseJSON: false });

    switch (`${dconId}`) {
      case DECConnectId.EC_USER:
      case DECConnectId.MYPAGE:
      case DECConnectId.SIGN_UP:
      case DECConnectId.POINT_ADDUP:
        return dconId;
      default:
        return null;
    }
  });
  const memberId = computed(() => {
    const memberId = $cookies.get(COOKIE_KEY.DCON_MEMBER_ID, { parseJSON: false });

    return typeof memberId === 'string' ? memberId : null;
  });

  const socialLoginParams = computed<SocialLoginParams>(() => {
    const { query } = route.value;
    const code = castArray(query.code)[0];
    const identifier = castArray(query.identifier)[0];
    const state = castArray(query.state)[0];

    return {
      code,
      identifier,
      state,
    };
  });

  const clearCookies = () => {
    $cookies.remove(COOKIE_KEY.DCON_ID);
    $cookies.remove(COOKIE_KEY.DCON_MEMBER_ID);
  };

  const handleError = () => {
    clearCookies();

    redirect(url('MYPAGE_POINT_LIST'));
  };

  return {
    dconId,
    memberId,
    socialLoginParams,
    clearCookies,
    handleError,
  };
};
